import { Card, Container, Input, FormButton, Text, Box } from "../components/UI"
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useSearchParams  } from 'react-router-dom';
import { useUserData } from "../hooks/useUserData";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import PasswordStrengthBar from 'react-password-strength-bar';

export const RegisterStep2 = () => {
    const navigate = useNavigate();
    const { handleSubmit, control, formState: { errors } } = useForm({ mode: 'onChange' });
    const {setPassword, lang} = useUserData();
    const onSubmit = data => {
        setPassword(data.password);
        navigate('/Register/Step3');
    }
    let [searchParams] = useSearchParams();
    
    return (
        <Box display="columnCenter">
            <Container>
                <Card>
                <Box display="rowStart">
                        <FontAwesomeIcon onClick={() => { navigate('/Register') }} icon={faArrowLeft} style={{ color: "white", cursor:"pointer", margin:6 }} />
                        <Text>{lang?.step2of3}</Text>
                    </Box>
                    <Text role="h1">{lang?.enterYourPassword}</Text>
                    <Text role="h3">{lang?.youWillUseThisPassword}</Text>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Controller
                            name="password"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                    message: lang?.passwordDoesNotMatchCriteria
                                }
                            }}

                            render={({ field }) => <><Input props={field} placeholder="Password" type="password" />
                                <PasswordStrengthBar password={field.value} /></>}
                        />

                        {errors.password && errors.password.type === "required" && (
                            <Text role="validationMessage">{lang?.passwordRequired}.</Text>
                        )}
                        {errors.password && errors.password.type !== "required" && (
                            <Text role="validationMessage">{errors.password.message}</Text>
                        )}
                        <Text role="subtitle">{lang?.useAMinimum}</Text>
                        <Card role="leftBordered">
                            <Text role="p">{lang?.youWillBeUsingThisEmail}</Text>
                            <Text role='h2'>{searchParams.get('email')}</Text>
                        </Card>

                        <FormButton role="secondary" title="Log In">
                        {lang?.continue}
                        </FormButton>
                    </form>
                    <Text>{lang?.doYouHaveAlreadyAnAccount}<Link to={`/`}>{lang?.loginNow}</Link> </Text>
                </Card>
            </Container>
        </Box>
    )
}